export enum GlobalEvent {
  BodyClick,
  Login,
  Logout,
  LogoutRequest,
  Shipments_FilterChangeRequest,
  Carrier_SelectedChanged
};
